import { useTranslation } from "react-i18next";
import React from "react";
import Modal from "@material-ui/core/Modal";
import Fade from "@material-ui/core/Fade";
import { Backdrop } from "@material-ui/core";
// import iconClose from "../../assets/images/02about_herings_team/window-close.svg";
import iconClose from "../../assets/images/02about_herings_team/closeIcon.svg";
import "./Aboutus.css";

export function AboutUsModal(props) {
  const { i18n } = useTranslation();
  // 국문판에서는 한글 성함과 우리말 소개글을 사용합니다.
  const isKr = i18n.language === "kr";
  const baseName = props.modalObj?.name || "";
  // 카드와 동일하게 "한글 이름, 학위" 형태로 표기
  const degrees = baseName.split(",").slice(1).join(",").trim();
  const nameText =
    isKr && props.modalObj?.nameKr ? props.modalObj.nameKr : baseName.split(",")[0].trim();
  const subLines = [degrees, props.modalObj?.positions || props.modalObj?.jobs].filter(
    Boolean
  );
  const detailText = (isKr && props.modalObj?.detailKr) || props.modalObj?.detail;
  // props : open, handleClose, modalObj
  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      id="aboutusmodal"
      className="modalNoOutline position-fixed flex align-items-center justify-center"
      open={props.open}
      onClose={props.handleClose}
      closeAfterTransition
      disableScrollLock={false}
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={props.open}>
        <div className="paper flex">
          {props.modalObj !== JSON.stringify({}) ? (
            <div className="modalContent">
              <div className="modalCloseDiv" onClick={props.handleClose}>
                <img src={iconClose} alt="close" className="modalClose" />
              </div>
              <div className="modalimgaeWrap">
                <img
                  src={props.modalObj?.modalimg}
                  alt={nameText}
                  className="modalimage"
                />
              </div>
              <div className="modalTitle mt-20 mb-20 flex-wrap-col align-items-center justify-center">
                <span
                  className="teamModalName textF22 FontB"
                  id="transition-modal-title"
                >
                  {nameText}
                </span>
                {subLines.map((line, i) => (
                  <span className="teamModalPosition textF16 FontB" key={i}>
                    {line}
                  </span>
                ))}
              </div>
              <div
                id="transition-modal-description"
                className="modalContentText textF16 FontR"
              >
                {detailText}
              </div>
            </div>
          ) : (
            <div> no info</div>
          )}
        </div>
      </Fade>
    </Modal>
  );
}
